// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cell_2Dl8K{vertical-align:middle;white-space:nowrap;height:56px}.icon_2F8fi{transform:translateY(8px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": "cell_2Dl8K",
	"icon": "icon_2F8fi"
};
module.exports = ___CSS_LOADER_EXPORT___;
